import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import Arrow from "~/images/arrow-curved-bottom-left-peach.svg";
import { StepContainer, StepLabel } from "~/OnboardingApp/components";
import { Trans } from "~/utils/i18next";

export const Steps: FC = () => {
  const { t } = useTranslation();

  return (
    <Flex justify="center" w="full">
      <Flex
        align="center"
        direction="column"
        gap={4}
        position="relative"
        w="fit-content"
      >
        <StepContainer>
          <Text
            textAlign="center"
            variant={{ base: "th-body2", md: "th-body1" }}
          >
            <Trans i18nKey="onboarding.welcomeNamePage.step1.content" />
          </Text>
          <StepLabel>
            {t("onboarding.welcomeNamePage.step1.estimatedTime")}
          </StepLabel>
        </StepContainer>
        <StepContainer>
          <Text
            textAlign="center"
            variant={{ base: "th-body2", md: "th-body1" }}
          >
            <Trans i18nKey="onboarding.welcomeNamePage.step2.content" />
          </Text>
        </StepContainer>
        <Box
          display={{ base: "none", lg: "initial" }}
          position="absolute"
          right="-6.25rem"
          top="2rem"
        >
          <Image alt="Bottom left arrow" src={Arrow} />
        </Box>
      </Flex>
    </Flex>
  );
};
